// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"4":"banner-lazy","40":"cookie-policy"}[chunkId] || chunkId) + ".lite.js?ver=" + {"4":"3f2edf9fc1277e14","40":"0fefebf99f8d76d1","227":"77e43ef245dd8195","327":"cf938dbfa5c1a86e"}[chunkId] + "";
};